import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=19b3fffa&"
import script from "./StartButton.vue?vue&type=script&lang=ts&"
export * from "./StartButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports